namespace $.$$ {

	$mol_style_define( $shm_hitalama_audio_player, {

		alignItems: 'center',
		gap: $mol_gap.block,
		padding: {
			left: $mol_gap.text,
			right: $mol_gap.text,
			bottom: $mol_gap.text,
		},
		flex: {
			grow: 1,
			shrink: 1,
		},
		minWidth: 0,

		Audio: {
			position: 'absolute',
			width: 0,
			height: 0,
			opacity: 0,
			pointerEvents: 'none',
		},

		Slider: {
			flex: {
				grow: 1,
				shrink: 1,
			},
			minWidth: '8rem',
		},

		Time: {
			display: 'block',
			whiteSpace: 'nowrap',
			font: {
				size: '12px',
			},
			color: $mol_theme.shade,
		},

		Play: {
			padding: 0,
			justify: {
				content: 'center'
			},
			Icon_unchecked: {
				width: '1.5rem',
				height: '1.5rem',
			},
			Icon_checked: {
				width: '1.5rem',
				height: '1.5rem',
			},
		},

	} )

}
